<template>
  <div class="app-container">
    <div class="paper-analysis-container">
      <!-- 顶部标题和返回按钮 -->
      <div class="header-section">
        <el-button icon="el-icon-arrow-left" size="small" @click="goBack">返回</el-button>
        <h2 class="page-title">试卷分析</h2>
      </div>

      <!-- 第一行：知识点题目得分率表格 -->
      <div class="analysis-row">
        <el-card class="analysis-card full-width">
          <div slot="header" class="card-header">
            <span>知识点题目得分率统计</span>
          </div>
          <el-table :data="knowledgeScoreData" border style="width: 100%" :header-cell-style="{backgroundColor: '#f5f7fa', color: '#606266'}">
            <el-table-column prop="knowledgePoint" label="知识点" width="180"></el-table-column>
            <el-table-column prop="questions" label="题目" width="180"></el-table-column>
            <el-table-column prop="classRate" label="班级得分率">
              <template slot-scope="scope">
                <el-progress :percentage="scope.row.classRate" :color="getColorByRate(scope.row.classRate)"></el-progress>
              </template>
            </el-table-column>
            <el-table-column prop="gradeRate" label="年级得分率">
              <template slot-scope="scope">
                <el-progress :percentage="scope.row.gradeRate" :color="getColorByRate(scope.row.gradeRate)"></el-progress>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>

      <!-- 第二行：知识点分析 -->
      <div class="analysis-row">
        <el-card class="analysis-card full-width">
          <div slot="header" class="card-header">
            <span>知识点分析</span>
          </div>
          <div class="knowledge-analysis">
            <div class="knowledge-item">
              <span class="knowledge-label">知识点1</span>
              <span class="knowledge-questions">1.1/1.2/1.3</span>
              <span class="knowledge-rate">80%</span>
              <span class="knowledge-level">良好</span>
            </div>
            <div class="knowledge-divider"></div>
            <!-- 可以添加更多知识点 -->
          </div>
        </el-card>
      </div>

      <!-- 第三行：各班级分数对比柱状表和各班各分数段对比折线表 -->
      <div class="analysis-row chart-row">
        <!-- 各班级分数对比柱状表 -->
        <el-card class="analysis-card chart-card">
          <div slot="header" class="card-header">
            <span>各班级分数对比</span>
          </div>
          <div class="chart-container" ref="classScoreComparisonChart"></div>
        </el-card>

        <!-- 各班各分数段对比折线表 -->
        <el-card class="analysis-card chart-card">
          <div slot="header" class="card-header">
            <span>各班各分数段对比</span>
          </div>
          <div class="chart-container" ref="classScoreRangeComparisonChart"></div>
        </el-card>
      </div>

      <!-- 第四行：各班优秀率及格率对比和各班成绩标准差对比 -->
      <div class="analysis-row chart-row">
        <!-- 各班优秀率及格率对比 -->
        <el-card class="analysis-card chart-card">
          <div slot="header" class="card-header">
            <span>各班优秀率及格率对比</span>
          </div>
          <div class="chart-container" ref="classPassRateComparisonChart"></div>
        </el-card>

        <!-- 各班成绩标准差对比 -->
        <el-card class="analysis-card chart-card">
          <div slot="header" class="card-header">
            <span>各班成绩标准差对比</span>
          </div>
          <div class="chart-container" ref="classStdDevComparisonChart"></div>
        </el-card>
      </div>

      <!-- 第五行：各题得分分布和各题得分趋势 -->
      <div class="analysis-row chart-row">
        <!-- 各题得分分布 -->
        <el-card class="analysis-card chart-card">
          <div slot="header" class="card-header">
            <span>各题得分分布</span>
          </div>
          <div class="chart-container" ref="scoreDistributionChart"></div>
        </el-card>

        <!-- 各题得分趋势 -->
        <el-card class="analysis-card chart-card">
          <div slot="header" class="card-header">
            <span>各题得分趋势</span>
          </div>
          <div class="chart-container" ref="scoreTrendChart"></div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
// 导入 ECharts 与 API
import * as echarts from 'echarts'
import { getClassPaperAnalysis } from '@/api/examAnalysis'

export default {
  name: 'PaperAnalysis',
  data() {
    return {
      // 试卷ID
      paperId: null,
      // 试卷基本信息
      paperInfo: {},
      // 知识点题目得分率数据
      knowledgeScoreData: [
        { knowledgePoint: '平行四边形的面积', questions: '1.1/1.2/1.3', classRate: 85, gradeRate: 80 },
        { knowledgePoint: '因数与倍数', questions: '2.1/2.2', classRate: 75, gradeRate: 72 },
        { knowledgePoint: '分数运算', questions: '3.1/3.2/3.3', classRate: 90, gradeRate: 85 },
        { knowledgePoint: '物体体积', questions: '4.1/4.2', classRate: 65, gradeRate: 68 }
      ],
      // 物理良好率数据
      rateData: [
        { label: '(1) 优秀', value: '90%' },
        { label: '(2) 良好', value: '80%' },
        { label: '(3) 及格', value: '70%' }
      ],
      // 各题得分率数据
      scoreRateData: [
        { question: '1.1', rate: 85 },
        { question: '1.2', rate: 78 },
        { question: '1.3', rate: 92 },
        { question: '2.1', rate: 65 },
        { question: '2.2', rate: 88 },
        { question: '2.3', rate: 72 }
      ],
      // 知识点分析数据
      knowledgeData: [
        { point: '知识点1', questions: '1.1/1.2/1.3', rate: '80%', level: '良好' }
      ],
      // 班级数据
      classData: [
        { name: '一班', avgScore: 85, excellentRate: 0.4, passRate: 0.95, stdDev: 8.5 },
        { name: '二班', avgScore: 78, excellentRate: 0.3, passRate: 0.9, stdDev: 10.2 },
        { name: '三班', avgScore: 82, excellentRate: 0.35, passRate: 0.92, stdDev: 9.3 },
        { name: '四班', avgScore: 76, excellentRate: 0.25, passRate: 0.88, stdDev: 11.5 }
      ],
      // 分数段数据
      scoreRangeData: {
        ranges: ['0-60', '60-70', '70-80', '80-90', '90-100'],
        classes: [
          { name: '一班', data: [5, 10, 20, 40, 25] },
          { name: '二班', data: [10, 15, 25, 30, 20] },
          { name: '三班', data: [8, 12, 22, 35, 23] },
          { name: '四班', data: [12, 18, 30, 25, 15] }
        ]
      },
      // 图表实例
      charts: {}
    }
  },
  created() {
    // 兼容多种来源：params.id / query.id / query.examId / localStorage 回退
    const route = this.$route || {}
    const candidates = [
      route.params && route.params.id,
      route.query && route.query.id,
      route.query && route.query.examId,
      localStorage.getItem('record_exam_examId')
    ]
    this.paperId = candidates.find(v => v !== undefined && v !== null && v !== '')

    const eid = Number(this.paperId)
    if (!eid || Number.isNaN(eid)) {
      console.error('paperAnalysis: 无法获取有效的 examId，candidates=', candidates)
      this.$message.error('未获取到试卷ID，无法加载分析数据')
      return
    }
    // 获取试卷分析数据（真实接口）
    this.fetchPaperAnalysisData(eid)
  },
  mounted() {
    // 初始化图表
    this.$nextTick(() => {
      this.initCharts()
    })
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1)
    },

    // 根据得分率获取颜色
    getColorByRate(rate) {
      if (rate >= 85) {
        return '#67c23a' // 绿色
      } else if (rate >= 70) {
        return '#409EFF' // 蓝色
      } else {
        return '#f56c6c' // 红色
      }
    },

    // 获取试卷分析数据（真实）
    async fetchPaperAnalysisData(eid) {
      try {
        const res = await getClassPaperAnalysis(Number(eid))
        if (res && res.code === 1 && res.data) {
          const data = res.data
          this.paperInfo = data.paperInfo || {}
          this.knowledgeScoreData = data.knowledgeScoreData || []
          this.classData = data.classData || []
          this.scoreRangeData = data.scoreRangeData || { ranges: [], classes: [] }

          // 用 scoreRangeData 渲染折线图
          this.$nextTick(() => {
            this.updateCharts()
          })
        } else {
          this.$message.error(res?.msg || '获取试卷分析数据失败')
        }
      } catch (e) {
        console.error('获取试卷分析失败:', e)
        this.$message.error('获取试卷分析失败')
      }
    },

    // 初始化所有图表
    initCharts() {
      // 初始化各班级分数对比柱状图
      this.initClassScoreComparisonChart()

      // 初始化各班各分数段对比折线图
      this.initClassScoreRangeComparisonChart()

      // 初始化各班优秀率及格率对比图
      this.initClassPassRateComparisonChart()

      // 初始化各班成绩标准差对比图
      this.initClassStdDevComparisonChart()

      // 初始化各题得分分布图
      this.initScoreDistributionChart()

      // 初始化各题得分趋势图
      this.initScoreTrendChart()

      // 监听窗口大小变化，重新调整图表大小
      window.addEventListener('resize', this.resizeCharts)
    },

    // 各班级分数对比柱状图
    initClassScoreComparisonChart() {
      const chartDom = this.$refs.classScoreComparisonChart
      if (!chartDom) return

      this.charts.classScoreComparison = echarts.init(chartDom)

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.classData.map(item => item.name),
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          name: '平均分',
          min: 0,
          max: 100
        },
        series: [
          {
            name: '平均分',
            type: 'bar',
            barWidth: '60%',
            data: this.classData.map(item => item.avgScore),
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#83bff6' },
                { offset: 0.5, color: '#188df0' },
                { offset: 1, color: '#188df0' }
              ])
            }
          }
        ]
      }

      this.charts.classScoreComparison.setOption(option)
    },

    // 各班各分数段对比折线图
    initClassScoreRangeComparisonChart() {
      const chartDom = this.$refs.classScoreRangeComparisonChart
      if (!chartDom) return

      this.charts.classScoreRangeComparison = echarts.init(chartDom)

      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: this.scoreRangeData.classes.map(item => item.name),
          bottom: 0
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.scoreRangeData.ranges
        },
        yAxis: {
          type: 'value',
          name: '人数',
          axisLabel: {
            formatter: '{value} 人'
          }
        },
        series: this.scoreRangeData.classes.map(classItem => ({
          name: classItem.name,
          type: 'line',
          data: classItem.data,
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          lineStyle: {
            width: 3
          }
        }))
      }

      this.charts.classScoreRangeComparison.setOption(option)
    },

    // 各班优秀率及格率对比图
    initClassPassRateComparisonChart() {
      const chartDom = this.$refs.classPassRateComparisonChart
      if (!chartDom) return

      this.charts.classPassRateComparison = echarts.init(chartDom)

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            return params[0].name + '<br/>' +
              params[0].seriesName + ': ' + (params[0].value * 100).toFixed(1) + '%<br/>' +
              params[1].seriesName + ': ' + (params[1].value * 100).toFixed(1) + '%'
          }
        },
        legend: {
          data: ['优秀率', '及格率'],
          bottom: 0
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.classData.map(item => item.name)
        },
        yAxis: {
          type: 'value',
          name: '比率',
          min: 0,
          max: 1,
          axisLabel: {
            formatter: function(value) {
              return (value * 100) + '%'
            }
          }
        },
        series: [
          {
            name: '优秀率',
            type: 'bar',
            stack: 'rate',
            emphasis: {
              focus: 'series'
            },
            data: this.classData.map(item => item.excellentRate),
            itemStyle: {
              color: '#91cc75'
            }
          },
          {
            name: '及格率',
            type: 'bar',
            stack: 'rate',
            emphasis: {
              focus: 'series'
            },
            data: this.classData.map(item => item.passRate),
            itemStyle: {
              color: '#5470c6'
            }
          }
        ]
      }

      this.charts.classPassRateComparison.setOption(option)
    },

    // 各班成绩标准差对比图
    initClassStdDevComparisonChart() {
      const chartDom = this.$refs.classStdDevComparisonChart
      if (!chartDom) return

      this.charts.classStdDevComparison = echarts.init(chartDom)

      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: '{b}: {c}'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.classData.map(item => item.name),
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          name: '标准差',
          min: 0
        },
        series: [
          {
            name: '标准差',
            type: 'bar',
            barWidth: '60%',
            data: this.classData.map(item => item.stdDev),
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#fac858' },
                { offset: 1, color: '#ee6666' }
              ])
            }
          }
        ]
      }

      this.charts.classStdDevComparison.setOption(option)
    },

    // 各题得分分布图
    initScoreDistributionChart() {
      const chartDom = this.$refs.scoreDistributionChart
      if (!chartDom) return

      this.charts.scoreDistribution = echarts.init(chartDom)

      // 模拟数据
      const questions = this.scoreRateData.map(item => item.question)
      const data = this.scoreRateData.map(item => item.rate)

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: questions,
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          name: '得分率',
          min: 0,
          max: 100,
          axisLabel: {
            formatter: '{value}%'
          }
        },
        series: [
          {
            name: '得分率',
            type: 'bar',
            barWidth: '60%',
            data: data,
            itemStyle: {
              color: function(params) {
                // 根据得分率设置不同颜色
                const value = params.data
                if (value >= 85) {
                  return '#91cc75' // 绿色
                } else if (value >= 70) {
                  return '#5470c6' // 蓝色
                } else {
                  return '#ee6666' // 红色
                }
              }
            }
          }
        ]
      }

      this.charts.scoreDistribution.setOption(option)
    },

    // 各题得分趋势图
    initScoreTrendChart() {
      const chartDom = this.$refs.scoreTrendChart
      if (!chartDom) return

      this.charts.scoreTrend = echarts.init(chartDom)

      // 模拟数据
      const questions = this.scoreRateData.map(item => item.question)
      const data = this.scoreRateData.map(item => item.rate)

      const option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: questions
        },
        yAxis: {
          type: 'value',
          name: '得分率',
          min: 0,
          max: 100,
          axisLabel: {
            formatter: '{value}%'
          }
        },
        series: [
          {
            name: '得分率',
            type: 'line',
            data: data,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              color: '#5470c6'
            },
            lineStyle: {
              width: 3,
              color: '#5470c6'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(84, 112, 198, 0.5)' },
                { offset: 1, color: 'rgba(84, 112, 198, 0.1)' }
              ])
            }
          }
        ]
      }

      this.charts.scoreTrend.setOption(option)
    },

    // 调整图表大小
    resizeCharts() {
      Object.keys(this.charts).forEach(key => {
        if (this.charts[key]) {
          this.charts[key].resize()
        }
      })
    },

    // 更新图表数据
    updateCharts() {
      // 更新各班级分数对比柱状图
      if (this.charts.classScoreComparison) {
        this.charts.classScoreComparison.setOption({
          xAxis: {
            data: this.classData.map(item => item.name)
          },
          series: [
            {
              data: this.classData.map(item => item.avgScore)
            }
          ]
        })
      }

      // 更新各班各分数段对比折线图（使用真实数据）
      if (this.charts.classScoreRangeComparison) {
        const legends = (this.scoreRangeData.classes || []).map(item => item.name)
        const xData = this.scoreRangeData.ranges || []
        const series = (this.scoreRangeData.classes || []).map(classItem => ({
          name: classItem.name,
          type: 'line',
          data: classItem.data || [],
          smooth: true,
          symbol: 'circle',
          symbolSize: 6
        }))
        this.charts.classScoreRangeComparison.setOption({
          legend: { data: legends },
          xAxis: { data: xData },
          series
        })
      }

      // 更新各班优秀率及格率对比图
      if (this.charts.classPassRateComparison) {
        this.charts.classPassRateComparison.setOption({
          xAxis: {
            data: this.classData.map(item => item.name)
          },
          series: [
            {
              data: this.classData.map(item => item.excellentRate)
            },
            {
              data: this.classData.map(item => item.passRate)
            }
          ]
        })
      }

      // 更新各班成绩标准差对比图
      if (this.charts.classStdDevComparison) {
        this.charts.classStdDevComparison.setOption({
          xAxis: {
            data: this.classData.map(item => item.name)
          },
          series: [
            {
              data: this.classData.map(item => item.stdDev)
            }
          ]
        })
      }

      // 更新其他图表...
    }
  },
  beforeDestroy() {
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.resizeCharts)

    // 销毁所有图表实例
    Object.keys(this.charts).forEach(key => {
      if (this.charts[key]) {
        this.charts[key].dispose()
      }
    })
  }
}
</script>

<style scoped>
.paper-analysis-container {
  padding: 20px;
}

.header-section {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  margin-left: 15px;
  font-size: 20px;
  font-weight: 500;
  color: #303133;
}

.analysis-row {
  display: flex;
  margin-bottom: 20px;
  gap: 20px;
}

.analysis-card {
  flex: 1;
  margin-bottom: 0;
}

.full-width {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.rate-content {
  padding: 10px 0;
}

.rate-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.5;
}

.rate-label {
  color: #606266;
}

.rate-value {
  color: #409EFF;
  font-weight: 500;
}

.score-rate-chart {
  height: 200px;
  position: relative;
}

.chart-labels {
  display: flex;
  justify-content: space-around;
  margin-bottom: 10px;
}

.chart-label {
  font-size: 14px;
  color: #606266;
}

.chart-content {
  height: 160px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.placeholder-chart {
  height: 100%;
  background: linear-gradient(to right, rgba(64, 158, 255, 0.1), rgba(64, 158, 255, 0.8));
  border-radius: 4px;
}

.knowledge-analysis {
  padding: 10px 0;
}

.knowledge-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.knowledge-label {
  width: 120px;
  color: #606266;
}

.knowledge-questions {
  width: 150px;
  color: #409EFF;
}

.knowledge-rate {
  width: 80px;
  color: #67c23a;
  font-weight: 500;
}

.knowledge-level {
  color: #e6a23c;
}

.knowledge-divider {
  height: 1px;
  background-color: #ebeef5;
  margin: 5px 0;
}

.chart-row {
  flex-wrap: wrap;
}

.chart-card {
  min-width: 45%;
  margin-bottom: 20px;
}

.chart-container {
  height: 300px;
  background-color: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 表格样式调整 */
.el-table {
  margin: 10px 0;
}

.el-progress {
  margin: 5px 0;
}

.chart-labels {
  display: flex;
  justify-content: space-around;
  margin-bottom: 10px;
}

.chart-label {
  font-size: 14px;
  color: #606266;
}

.chart-content {
  height: 160px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.placeholder-chart {
  height: 100%;
  background: linear-gradient(to right, rgba(64, 158, 255, 0.1), rgba(64, 158, 255, 0.8));
  border-radius: 4px;
}

.knowledge-analysis {
  padding: 10px 0;
}

.knowledge-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.knowledge-label {
  width: 120px;
  color: #606266;
}

.knowledge-questions {
  width: 150px;
  color: #409EFF;
}

.knowledge-rate {
  width: 80px;
  color: #67c23a;
  font-weight: 500;
}

.knowledge-level {
  color: #e6a23c;
}

.knowledge-divider {
  height: 1px;
  background-color: #ebeef5;
  margin: 5px 0;
}

.chart-row {
  flex-wrap: wrap;
}

.chart-card {
  min-width: 45%;
  margin-bottom: 20px;
}

.chart-container {
  height: 300px;
  background-color: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 响应式调整 */
@media screen and (max-width: 1200px) {
  .analysis-row {
    flex-direction: column;
  }

  .chart-card {
    width: 100%;
  }
}
</style>
